import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, isValidElement, cloneElement } from 'react';
import { InternalLayerValue } from '@hh.ru/magritte-internal-layer-name';
import { LayerValue } from './types.js';

const LAYER_VALUES = { ...InternalLayerValue, ...LayerValue };
const LayerContext = createContext(0);
const Layer = ({ children, layer }) => {
    const baseLayerValue = useContext(LayerContext);
    const index = LAYER_VALUES[layer];
    const currentIndex = baseLayerValue + index;
    const cloneChild = (child) => {
        return isValidElement(child)
            ? cloneElement(child, { style: { ...child.props.style, zIndex: `${currentIndex}` } })
            : child;
    };
    return (jsx(LayerContext.Provider, { value: currentIndex, children: Array.isArray(children) ? children.map(cloneChild) : cloneChild(children) }));
};

export { Layer, LayerContext };
//# sourceMappingURL=Layer.js.map
